var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 37,
    viewBox: "0 0 47 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 23.8502C0 14.1812 5.19407 5.54356 13.0485 0L20.0162 5.67248C15.9623 7.86411 11.2749 13.2787 10.1348 17.9199C10.5148 17.662 11.655 17.5331 12.6685 17.5331C17.4825 17.5331 21.283 21.2718 21.283 26.8153C21.283 32.3589 16.7224 37 11.2749 37C5.32075 37 0 32.23 0 23.8502ZM25.8437 23.8502C25.8437 14.1812 30.9111 5.54356 38.7655 0L45.8598 5.67248C41.8059 7.86411 36.9919 13.2787 35.9784 17.9199C36.3585 17.662 37.4987 17.5331 38.5121 17.5331C43.1995 17.5331 47 21.2718 47 26.8153C47 32.3589 42.566 37 36.9919 37C31.0377 37 25.8437 32.23 25.8437 23.8502Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotes);
export default __webpack_public_path__ + "static/media/quotes.dec71b9ad6a238fc601b5ef22c80f1a6.svg";
export { ForwardRef as ReactComponent };